import '../../../css/bundles/clean-look/index.scss';
import { isSupportFormatWebp } from '../../redesign/utils/isSuppoertFormatWebp';
import { sendEventYM } from '../../redesign/utils/common';

const webpElements = document.querySelectorAll('[data-webp-checker]');
const webpSupport = isSupportFormatWebp();

webpElements.forEach((el) => {
  if (webpSupport) {
    el.classList.add('webp');
  }
});

// Скачать гайд
const btnGuideCleanLook = document.querySelector('[data-btn-guide-clean-look]');
if (btnGuideCleanLook) {
  btnGuideCleanLook.addEventListener('click', () => {
    sendEventYM('saved_material_eco_initiatives');
  });
}
